document.addEventListener('DOMContentLoaded', function() {
  const sortSelects = document.querySelectorAll('select[name="sort_by"]');
  sortSelects.forEach(function(select) {
    ['manual', 'best-selling', 'title-ascending', 'title-descending'].forEach(function(val) {
      const opt = select.querySelector('option[value="' + val + '"]');
      if (opt) opt.remove();
    });
  });
});